import { generateImagePath } from '../../helpers/helpers';

export default function NavBar({
  toggleSidebar,
}: {
  toggleSidebar: () => void;
}) {
  return (
    <div className="sticky-navbar">
      <div className="navbar navbar-expand-lg navbar-light bg-light customShadow">
        <div>
          <span
            onClick={toggleSidebar}
            className="navbar-toggler-icon cursorPointer d-lg-none d-block mx-3 custom-border"
          ></span>
        </div>
        <div className="col-lg-2 col-md-3 d-block px-3 py-2 ms-lg-0 ms-auto">
          <div className="navbar-brand">
            <img
              src={generateImagePath('logo.webp')}
              alt=""
              className="navBarImage"
              width="35"
              height="40"
            />
          </div>
        </div>
        <div>
          <span
            onClick={toggleSidebar}
            className="navbar-toggler-icon cursorPointer d-lg-block d-none custom-border"
          ></span>
        </div>
      </div>
    </div>
  );
}
